/**
 * @author Wentong Liu
 */
'use strict';

export default {
  getUserLocation1: 'https://ipinfo.io/json?token=7d3fdbb7d30207',
  getUserLocation2: 'https://reallyfreegeoip.org/json/',

  /* Auth */
  login: '/v2/auth/customer-login',
  register: '/v2/auth/register',
  registerResend: '/v2/auth/register-resend',
  getLogo: (email) => `/v2/providers/email/${email}`,
  usersMe: `/v3/users/me`,

  /* projects */
  addProject: `/v2/projects/link-project`,
  projects: `/v3/projects`,
  addProjectAdmin: (serial) => `/v2/admin-projects/link-project/${serial}`,
  inviteProvider: (projectId) => `/v2/projects/invite/${projectId}`,
  unlinkProvider: (projectId, providerId) => `/v2/projects/${projectId}/provider/${providerId}`,

  /* Performance */
  getMyProjectsProvider: `/v2/providers/me/projects`,
  getMyProjectsConsumer: `/v2/consumers/me/properties`,
  getProjectDetails: (projectId) => `/v2/projects/${projectId}`,
  getProjectHourlySnapshots: (projectId, from, to) =>
    `/v2/projects/${projectId}/snapshots?type=hourly&from=${from}&to=${to}`,
  getMeterHourlySnapshots: (meterId, from, to) =>
    `/v2/meters/${meterId}/snapshots?type=hourly&from=${from}&to=${to}`,
  getMeterWithProperties: (meterId) => `/v2/meters/${meterId}/properties`,
  getPropertyHourlySnapshots: (propertyId, from, to) =>
    `/v2/properties/${propertyId}/snapshots?type=hourly&from=${from}&to=${to}`,
  downloadCSV: (projectId) => `/v2/snapshot/${projectId}/csv`,

  /* Alert */
  getAlertConfiguration: (propertyId) => `/v2/projects/${propertyId}/alerts`,
  createBatteryTripAlert: `/v2/alert-setting/alert-battery-trips`,
  createInverterTripAlert: `/v2/alert-setting/alert-inverter-trips`,
  createSolshareOfflineAlert: `/v2/alert-setting/alert-solshare-offlines`,
  createEnergyLimitAlert: `/v2/alert-setting/alert-energy-limits`,
  createAlertEmail: `/v2/alert-setting/alert-emails`,
  updateBatteryTripAlert: (alertId) => `/v2/alert-setting/alert-battery-trips/${alertId}`,
  updateInverterTripAlert: (alertId) => `/v2/alert-setting/alert-inverter-trips/${alertId}`,
  updateSolshareOfflineAlert: (alertId) => `/v2/alert-setting/alert-solshare-offlines/${alertId}`,
  updateEnergyLimitAlert: (alertId) => `/v2/alert-setting/alert-energy-limits/${alertId}`,
  updateAlertEmail: (alertId) => `/v2/alert-setting/alert-emails/${alertId}`,

  /* Battery */
  getBatteryInfo: (projectId) => `/v2/projects/${projectId}/batteries`,
  chargingSchedule: (deviceId) => `/v2/charging-schedules/${deviceId}`,

  /* Setting */
  updateProvider: `/v2/providers/profile`,
  updateEmail: `/v2/auth/change-email`,
  updatePassword: `/v2/auth/change-pwd`,
  deleteAccount: (token) => `/v2/auth/delete-account/${token}`,
  confirmDeleteAccount: `/v2/auth/delete-account`,
  forgetPassword: `/v2/auth/forget-password`,
  resetPassword: `/v2/auth/reset-password`,
  tcRead: `/v2/auth/tc-read`,
  checkEmailAvailability: `/v3/auth/email-availability`,

  /* Site Configuration */
  getSolshareInfo: (serial) => `/v2/service-interface/system-info/${serial}`,
  uploadConfig: (serial) => `/v2/service-interface/solar-delivery-method/${serial}`,
  getSolshareSoftware: (serial) => `/v3/solshares/${serial}/software`,

  /* Billing */
  getPaymentPortalSession: `/v2/payment/portal`,
  getSubscription: `/v2/payment/subscription`,
  postSubscriptionUsage: (subscriptionId) => `/v2/payment/usage/${subscriptionId}`,

  /* Financial Tab */
  uploadSolarAccessFee: (meterId) => `/v2/meters/${meterId}/solar-access-fee`,
  togglePropertySolarAccessFeeEnabled: (meterId) => `/v2/meters/${meterId}/toggle-solar-access-fee`,
  getMeterPropertySavings: (meterId) => `/v2/meters/${meterId}/property-savings`,
  getMeterRevenue: (meterId) => `/v2/meters/${meterId}/revenue`,
};

/* Commission flow */
export const comApi = {
  login: '/v2/auth/commissioner/login',
  commRegister: '/v2/auth/commissioner/register',
  forgetPassword: '/v2/auth/commissioner/forget-password',
  resetPassword: '/v2/auth/commissioner/reset-password',
  getSolShare: (serial) => `/v2/commission/meter/${serial}`,
  getSolshareSoftware: (serial) => `/v3/solshares/${serial}/software`,
  applySolshareSoftware: (serial) => `/v3/solshares/${serial}/software`,
  updateMeter: (serial) => `/v3/meters/${serial}`,
  getSolshareConfig: (serial) => `/v2/commission/upload-config/${serial}`,
  uploadConfig: () => `/v2/commission/upload-config`,
  uploadSpecs: (serial) => `/v2/commission/upload-config/spec/${serial}`,
  uploadConnection: (serial) => `/v2/commission/upload-config/connection/${serial}`,
  addWarrantyContact: (projectId) => `/v3/projects/${projectId}/provider-contacts`,
  commissionCommand: (serial) => `/v3/meters/${serial}/command`,
  getMeterAppState: (serial) => `/v3/meters/${serial}/state`,
  commissionConfigStatus: (serial) => `/v2/commission/config-status/${serial}`,
  commissionStatus: (serial) => `/v2/commission/meter/${serial}/state`,
  commissionResultStatus: (serial, commission_id) =>
    `/v2/commission/meter/${serial}/results/${commission_id}`,
  meterWifiStatus: (serial) => `/v2/commission/wifi/${serial}`,
  inviteAssetManager: (serial) => `/v2/projects/invite/meter/${serial}`,
  addSitesToProject: (projectId) => `/v3/projects/${projectId}/sites`,
  netPromoterScore: '/v2/commission/net-promoter-score',
};
